import React from 'react';
import Icon from '../../../components/AppIcon';

const GenericFilePreview = ({ file }) => {
  const getFileIcon = () => {
    if (file?.type?.includes('zip') || file?.type?.includes('archive')) return 'Archive';
    if (file?.type?.includes('audio')) return 'Music';
    if (file?.type?.includes('text')) return 'FileText';
    if (file?.type?.includes('code') || file?.type?.includes('json') || file?.type?.includes('xml')) return 'Code';
    return 'File';
  };

  return (
    <div className="w-full h-full bg-muted rounded-lg flex flex-col items-center justify-center p-8">
      <div className="bg-card rounded-full p-6 mb-6 shadow-md">
        <Icon name={getFileIcon()} size={64} className="text-muted-foreground" />
      </div>
      <h3 className="text-lg font-semibold text-foreground mb-2">
        No Preview Available
      </h3>
      <p className="text-sm text-muted-foreground text-center max-w-md mb-6">
        This file type cannot be previewed in the browser. Download the file to view its contents.
      </p>
      <div className="w-full max-w-md bg-card border border-border rounded-lg p-4">
        <div className="space-y-3">
          <div className="flex justify-between items-center">
            <span className="text-xs text-muted-foreground">File Name</span>
            <span className="text-xs font-medium text-foreground font-mono truncate max-w-[200px]">
              {file?.name}
            </span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-xs text-muted-foreground">File Type</span>
            <span className="text-xs font-medium text-foreground">{file?.type}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-xs text-muted-foreground">File Size</span>
            <span className="text-xs font-medium text-foreground font-mono">
              {(file?.size / 1024)?.toFixed(2)} KB
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GenericFilePreview;